module.exports = __webpack_public_path__ + "assets/img/icon_swiper_mini_next.f5f5de3e.svg";